import { render, staticRenderFns } from "./unitMeasureManagement.vue?vue&type=template&id=0ec863e6&scoped=true"
import script from "./unitMeasureManagement.vue?vue&type=script&lang=js"
export * from "./unitMeasureManagement.vue?vue&type=script&lang=js"
import style0 from "./unitMeasureManagement.vue?vue&type=style&index=0&id=0ec863e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec863e6",
  null
  
)

export default component.exports